import { create } from 'zustand'
import {
  ExamListPayloadInterface,
  GetExamInfoForTestCentreAdminInterface,
  ICentreExamInfo,
  ICentreExamInfoWrapper,
} from "../interfaces/exam.interface";

import { CustomerStoreTypes } from './storeTypes/customerStoreTypes';
import { CenterList, CustomerDetailList, CustomerResp } from '../interfaces/customer.interface';



const useCustomerStore = create<CustomerStoreTypes>((set) => ({
 customerAllList:{
    total_count: 0,
    page_index: 0,
    page_size: 0,
    resp: []
  },
  setCustomerAllList:(data:CustomerDetailList)=>set(()=>({customerAllList:data})),
  
centerAllList:{
    counts:0,
    result:[]
},
setCenterAllList:(data:CenterList)=>set(()=>({centerAllList:data})),
customerListAutoComplete:[],
setCustomerListAutoComplete:(data:CustomerResp[])=>set(()=>({customerListAutoComplete:data})),
createCustomerRes:null,
setCreateCustomerRes:(data:any)=>set(()=>({createCustomerRes:data})),
selectedCustomerGlobally:null,
setSelectedCustomerGlobally:(data:CustomerResp|null)=>set(()=>({selectedCustomerGlobally:data})),
customerCreditBalance:0,
setCreditBalance:(data:number)=>set(()=>({customerCreditBalance:data}))


}))

export default useCustomerStore